var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(
      _vm.$router.currentRoute.name !== 'Login' &&
      _vm.$router.currentRoute.name !== 'Login' &&
      _vm.$router.currentRoute.name !== 'CreateLineOAaccount' &&
      _vm.$router.currentRoute.name !== 'thank' &&
      _vm.$router.currentRoute.name !== 'BillingPlan' &&
      _vm.$router.currentRoute.name !== 'ver2' &&
      _vm.$router.currentRoute.name !== 'googleLogin' &&
      _vm.$router.currentRoute.name !== 'facebookLogin'&&
      // LV2
      _vm.$router.currentRoute.name !== 'signUp' &&
      _vm.$router.currentRoute.name !== 'form' &&
      _vm.$router.currentRoute.name !== 'createBranch' &&
      _vm.$router.currentRoute.name !== 'theme' &&
      _vm.$router.currentRoute.name !== 'payment' &&
      _vm.$router.currentRoute.name !== 'addpoint' &&
      _vm.$router.currentRoute.name !== 'staff' &&
      _vm.$router.currentRoute.name !== 'Register' &&
      _vm.$router.currentRoute.name !== 'Reward' &&
      _vm.$router.currentRoute.name !== 'convertRate' &&
      _vm.$router.currentRoute.name !== 'Random' &&
      _vm.$router.currentRoute.name !== 'RandomCGS'
    )?_c('Sidebar'):_vm._e(),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('BroadcastProgressPopup')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-285f5d32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 